import { changeBaseUrl } from './changeBaseUrl';
import { VERTICAL_EMBED_TYPE } from 'wix-rich-content-common';
export function verticalEmbedViewerStrategy(baseUrl, disabled) {
    var _a;
    if (disabled === void 0) { disabled = false; }
    return {
        config: (_a = {},
            _a[VERTICAL_EMBED_TYPE] = {
                changeBaseUrl: function (url) { return changeBaseUrl(url, baseUrl); },
                disabled: disabled,
            },
            _a),
    };
}
//# sourceMappingURL=verticalEmbedViewerStrategy.js.map